import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import CanalSelect from "./CanalSelect.js"

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"
import CreateLTE from "../../clientes/Responsables/Create.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            ltp_id: null,
            lte_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            empresa_id: null,
            canal_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            ltp_id: null,
            lte_id: null,
        })
    }

    setSelects(data) {
        this.setState({
            departamento_id: data.departamentointerno_id,
            departamentopadre_id: data.departamentointernopadre_id,
            empresa_id: data.empresa_id,
            canal_id: data.canal_id,
            ltp_id: data.ltp_id,
            lte_id: data.lte_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.edit}
                postUrl={api.proyectos.solicitudes.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Asignar Líderes"}
                buttonTitle={"Asignar Líderes"}
                buttonIcon={"fa fa-user fa-lg"}
                notAllowedMessage={"La Solicitud no puede ser editada en esta etapa porque ya fue avanzada."}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >


                <ParadigmaLabeledInput labelColumns={4} fieldColumns={8} label={"Grupo"}
                    inputComponent={<ParadigmaAsyncSeeker disabled={true} fieldName={""}
                        url={api.usuarios.grupos.select} value={this.state.departamentopadre_id} />} />

                <ParadigmaLabeledInput labelColumns={4} fieldColumns={8} label={"Subgrupo"}
                    inputComponent={<ParadigmaAsyncSeeker disabled={true} fieldName={"departamentointerno_id"}
                        url={api.usuarios.subgrupos.select} value={this.state.departamento_id} />} />

                <ParadigmaLabeledInput disabled={true} labelColumns={4} fieldColumns={8} label={"Código"} fieldName={"codigo"} />

                <ParadigmaLabeledInput disabled={true} labelColumns={4} fieldColumns={8} label={"Título"} fieldName={"nombre"} />
                <ParadigmaLabeledInput disabled={true} labelColumns={4} fieldColumns={8} label={"Forma de Contacto"}
                    inputComponent={<CanalSelect value={this.state.canal_id} disabled={true} />} />

                <ParadigmaLabeledInput disabled={true} labelColumns={4} fieldColumns={8} label={"Empresa/Organización"}
                    inputComponent={<ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"}
                        url={api.clientes.empresas.select} value={this.state.empresa_id} disabled={true} />} />

                <ParadigmaLabeledInput disabled={true} type={"textarea"}
                    rows={10}
                    labelColumns={12} fieldColumns={12} label={"Observaciones"} fieldName={"observaciones"} />

                <ParadigmaLabeledInput disabled={true} labelColumns={5} fieldColumns={7} label={"Líder Técnico Proyecto"}
                    inputComponent={<ParadigmaAsyncSeeker fieldName={"ltp_id"}
                        url={api.usuarios.usuarios.select} value={this.state.ltp_id} />} />

                {this.state.empresa_id &&
                    <ParadigmaLabeledInput disabled={true} labelColumns={5} fieldColumns={7} label={"Líder Técnico Empresa"}
                        inputComponent={<ParadigmaAsyncSeeker Create={CreateLTE} fieldName={"lte_id"} nombreField={"fullname"}
                            url={api.clientes.responsables.select + "?tipo=1&empresa_id=" + this.state.empresa_id} value={this.state.lte_id} />} />
                }
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Asignar.js